import React, { useContext } from "react";
import { Cell, Filters, Row } from "react-table";
import AbpnSpinner from "../Shared/Components/AbpnSpinner";
import HeaderWithTitle from "../Shared/Components/HeaderWithTitle";
import { PreCertTable } from "../Shared/Components/PreCertTable";
import Resident from "../Residents/Models/Resident";
import { getDateWithOffset } from "../Shared/Utility/GetDateWithOffset";
import { Card } from "react-bootstrap";
import { PostGraduateYear } from "../Training/Models/PostGraduateYear";
import { ProfileContext } from "../Auth/ProfileProvider";
import { Link } from "react-router-dom";
import { AlumniRosterContext } from "../Contexts/AlumniRosterProvider";

export function AlumniRoster() {
    const { user } = useContext(ProfileContext);
    const { roster, filteredRoster, filters, isRosterLoading, updateFilteredRoster, updateFilters } = useContext(AlumniRosterContext);

    const getProgramLastPgyAttended = (years: Array<PostGraduateYear>) => {
        let programYears = years.filter(_ => _.trainingProgramId === user.selectedTrainingProgramId);
        let sortedYears = programYears.sort((a, b) => new Date(a.endDate).getTime() - new Date(b.endDate).getTime());

        return sortedYears[sortedYears.length - 1];
    }

    const onFiltersChanged = (rows: Array<Row<Resident>>, filters: Filters<object>) => {
        var residents = rows.map(_ => { return _.original });
        updateFilteredRoster(residents);
        updateFilters(filters);
    }

    const getPGYdisplay = (years: Array<PostGraduateYear>) => {
        if (!years?.length) return "";
        let lastPgyAttended = getProgramLastPgyAttended(years);
        let lastPgyEndDate = new Date(lastPgyAttended.endDate);

        return `${lastPgyEndDate.getFullYear()}`
    }

    const columns = React.useMemo(
        () => [
            {
                Header: "First",
                width: "auto",
                filterable: true,
                sortable: true,
                filterType: "fuzzyText",
                accessor: (resident: Resident) => resident.name.firstName,
                id: "arFirstName"
            },
            {
                Header: "Middle",
                width: "100",
                filterable: true,
                sortable: true,
                filter: "fuzzyText",
                accessor: (resident: Resident) => resident.name.middleName,
                id: "arMiddleName"
            },
            {
                Header: "Last",
                width: "auto",
                filterable: true,
                sortable: true,
                filter: "fuzzyText",
                accessor: (resident: Resident) => resident.name.lastName,
                id: "arLastName"
            },
            {
                Header: "Date Of Birth",
                width: "150px",
                filterable: true,
                sortable: true,
                filter: 'fuzzyDate',
                accessor: (resident: Resident) => getDateWithOffset(resident.dateOfBirth).valueOf(),
                Cell: (a: Cell<Resident>) => <div className="text-end">{getDateWithOffset(a.row.original.dateOfBirth).toLocaleDateString()}</div>,
                id: "arDob"
            },
            {
                Header: "SSN4",
                width: "100px",
                filterable: true,
                sortable: true,
                filter: "fuzzyText",
                accessor: (resident: Resident) => resident.ssn4,
                id: "arSSN4"
            },
            {
                Header: "Final Year",
                width: "120px",
                filterable: true,
                sortable: true,
                filter: "fuzzyText",
                accessor: (resident: Resident) => getPGYdisplay(resident.postGraduateYears),
                id: "arPgy"
            },
            {
                Header: "Completed",
                width: "100px",
                filterable: true,
                sortable: true,
                filter: "fuzzyText",
                accessor: (resident: Resident) => resident.completedTrainingProgramIds.find(_ => _ === user.selectedTrainingProgramId) ? 'Yes' : 'No',
                id: "arCompleted"
            },
            {
                id: "arActions",
                width: "auto",
                Cell: (a: Cell<Resident>) =>
                    <Link
                        className="link-primary me-3"
                        to={`${a.row.original.physicianId}`}
                    >
                        View Details
                    </Link>
            }
        ],
        []
    )

    const residentsMessage = roster && filteredRoster &&
        (filteredRoster.length < roster.length ?
            `${filteredRoster.length} of `
            : ''
        ) + `${roster?.length ?? 0} alumni`;

    if (isRosterLoading) return <AbpnSpinner />;
    const alumniRoster = roster?.length > 0 ? <PreCertTable columns={columns} data={roster} defaultPageSize={15} onFiltersChanged={onFiltersChanged} defaultFilters={filters} /> : <span>No Alumni</span>;

    return (
        <>
            <div className="d-flex justify-content-between">
                <HeaderWithTitle title={'Alumni'} subTitle={""} />
                <div className="d-flex flex-column">
                    <Card.Text className="align-self-end fw-bolder mt-2">{residentsMessage}</Card.Text>
                </div>
            </div>
            {alumniRoster}
        </>
    );
}